import $ from 'jquery';
import EFOcats_event_page from '../../../core/v2/event/efocats_event_page';
import EFOcats_import_html from '../../../core/v2/import/efocats_import_html';
import EFOcats_import_lang from '../../../core/v2/import/efocats_import_lang';

export default class EFOcats_curves_event_page extends EFOcats_event_page {
  /**
   * 開始ページの戻るボタンの処理
   * @param {*} element
   */
  startpage_back(element) {
    $(this.pager_back_selector)[0].click();
    $('#efocats').hide();
    $('#cat-dummy-layer').hide();

    $('[name="room_name"]').val('');
    const val = $('[name="room_name"]').val();

    // chageが登録されないのでintervalで対応
    const timer = setInterval(() => {
      if (val !== $('[name="room_name"]').val()) {
        $('#efocats').show();
        $('#cat-dummy-layer').show();
        clearInterval(timer);
      }
    }, 100);
  }

  event() {
    super.event();

    window.addEventListener('popstate', e => {
      if ($('#efocats').css('display') !== 'none') {
        window.history.pushState(null, null, null);
        this.startpage_back(null);
      }
    });
  }

  /**
   * ページ遷移ボタンの作成
   * @param {*} number
   * @param {*} tmp
   * @param {*} elem
   */
  createPager() {
    for (let number = 0; number < this.$('.cat-section').length; number++) {
      const page = this.$('.cat-section').eq(number);

      if (number === 0) {
        // 開始ページの場合
        this.createPager_startpage(page);
      } else {
        // qaの場合
        this.createPager_qapage(page);
      }
    }

    // 送信ボタン生成
    if (this.$('.checkPage').length === 0) {
      if (options === 2) {
        this.$('body')
          .find('.cat-section:last-child')
          .find('.pager')
          .html(EFOcats_import_html.getValue('btn_submit', {label: EFOcats_import_lang.getValue('確認2')}));
      } else {
        this.$('body')
          .find('.cat-section:last-child')
          .find('.pager')
          .html(EFOcats_import_html.getValue('btn_submit', {label: EFOcats_import_lang.getValue('確認')}));
      }
    }
  }
}
